import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import ProfileForm from './ProfileForm';
import LinearProgress from '@material-ui/core/LinearProgress';

export default function MyAccountDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
      <Dialog
        fullScreen={fullScreen}
        open={props.open}
        onClose={props.onClose}
        aria-labelledby="dialog-title"
      >
        <DialogTitle id="dialog-title">My Profile</DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            <ProfileForm hideButtons={true} {...props.formProps} onSubmit={props.onSubmit} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose} color="inherit">
            Close
          </Button>
          <Button variant='contained' autoFocus disabled={props.inProgress} onClick={props.onSave} color="primary" autoFocus>
            Save changes
          </Button>
        </DialogActions>
        {props.inProgress ? <LinearProgress /> : '' }
      </Dialog>
  );
}
